import React from 'react';
import { Icon } from './Icon.js';
export const IconChatBubbleSmile = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M22 4H2V22H4L6.25 18H22V4Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M16 12.0005C15.0878 13.2147 13.6356 14 12 14C10.3644 14 8.91223 13.2147 8 12.0005", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChatBubbleSmile.js.map